export default "__VITE_ASSET__HwvqvoHc__"